<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3719 12.9463H3.6268M16.3719 12.9463V6.66659C16.3719 5.09524 16.3719 4.30956 15.8838 3.82141C15.3956 3.33325 14.6099 3.33325 13.0386 3.33325H6.96013C5.38878 3.33325 4.60311 3.33325 4.11496 3.82141C3.6268 4.30956 3.6268 5.09524 3.6268 6.66659V12.9463M16.3719 12.9463L17.8253 14.4464C17.8623 14.4848 17.8809 14.5039 17.8983 14.5229C18.1658 14.8168 18.3196 15.1964 18.3318 15.5936C18.3327 15.6193 18.3327 15.646 18.3327 15.6993C18.3327 15.8237 18.3327 15.8858 18.3293 15.9383C18.2764 16.7761 17.6088 17.4437 16.7711 17.4966C16.7186 17.4999 16.6564 17.4999 16.5321 17.4999H3.46658C3.34225 17.4999 3.28008 17.4999 3.22758 17.4966C2.38989 17.4437 1.72226 16.7761 1.66933 15.9383C1.66602 15.8858 1.66602 15.8237 1.66602 15.6993C1.66602 15.646 1.66602 15.6193 1.66682 15.5936C1.67909 15.1964 1.83287 14.8168 2.10041 14.5229C2.11775 14.5039 2.13633 14.4848 2.17342 14.4464L3.6268 12.9463"
      stroke="white"
      stroke-linecap="round"
      stroke-width="1.5"
    />
    <path
      d="M7.91602 15.4165H12.0827"
      opacity="0.5"
      stroke="white"
      stroke-linecap="round"
      stroke-width="1.5"
    />
    <path
      d="M10.625 5.625C10.625 5.97017 10.3452 6.25 10 6.25C9.65483 6.25 9.375 5.97017 9.375 5.625C9.375 5.27983 9.65483 5 10 5C10.3452 5 10.625 5.27983 10.625 5.625Z"
      fill="white"
      opacity="0.5"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpWhoIsForIcon3',
}
</script>